import { BaseDialog } from "../Dialog/BaseDialog";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { RatingInput } from "@/lib/Components/Form/Inputs/RatingInput";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { CreateWorkOrderDriverReviewInput } from "@/gql/graphql";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { createProDriverReview } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrderDriverMutations";

export interface RatingDialogProps {
  assignmentId?: string;
  proDriverId: string;
  initialValues?: Partial<CreateWorkOrderDriverReviewInput>;
}

export function CreateReviewDialog({
  assignmentId,
  proDriverId,
  initialValues,
}: RatingDialogProps) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(createProDriverReview);

  return (
    <BaseDialog
      title={`Rate Driver`}
      subtitle="How would you rate this driver's performance?"
    >
      <GenericForm<CreateWorkOrderDriverReviewInput>
        initialValues={{
          rating: 0,
          comment: "",
          pro_driver_id: proDriverId,
          ...(assignmentId ? { work_order_assignment_id: assignmentId } : {}),
          ...initialValues,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });
          return close();
        }}
      >
        <RatingInput label="Rating" name="rating" size="lg" showValue />

        <TextAreaInput
          autoFocus
          label="Comment"
          className="col-span-full"
          name="comment"
          textAreaProps={{
            placeholder:
              "Share any additional feedback about the driver's performance...",
          }}
        />

        <DialogSubmitButton text="Submit" />
      </GenericForm>
    </BaseDialog>
  );
}
